import type {
  CheckoutPaymentProps,
  DisplayedFieldsGetter
} from '../../../common';
import { PAYMENT_EMAIL_FIELD } from '../../../common';
import { defaultGetDisplayedFields } from './default-get-displayed-fields';

// если необходимо, добавляет обязательное email-поле
// и патчит обработчик getDisplayedFields,
// чтобы новое добавленное поле не отображалось на этапе формы
export function ensureCheckoutSettingsPrepared(
  settings: CheckoutPaymentProps
): CheckoutPaymentProps {
  if (!settings.withInternalForm) {
    return settings;
  }

  const { formPageSettings, paymentPageSettings } = settings;

  const { formLayoutProps, formSettings } = formPageSettings;
  const { emailFieldId } = paymentPageSettings;

  const { getDisplayedFields = defaultGetDisplayedFields } = formLayoutProps;
  const { fields } = formSettings;

  if (
    emailFieldId &&
    fields.some(({ id, type }) => id === emailFieldId && type === 'email')
  ) {
    return settings;
  }

  const preparedPaymentPageSettings = {
    ...paymentPageSettings,
    emailFieldId: PAYMENT_EMAIL_FIELD.id
  };

  const fieldsWithEmail = [...fields, PAYMENT_EMAIL_FIELD];
  const preparedFormSettings = {
    ...formSettings,
    fields: fieldsWithEmail
  };

  const preparedGetDisplayFields: DisplayedFieldsGetter = (fields) => {
    return getDisplayedFields(fields).filter(
      ({ id }) => id !== PAYMENT_EMAIL_FIELD.id
    );
  };
  const preparedFormLayoutProps = {
    ...formLayoutProps,
    getDisplayedFields: preparedGetDisplayFields
  };

  const preparedFormPageSettings = {
    ...formPageSettings,
    formSettings: preparedFormSettings,
    formLayoutProps: preparedFormLayoutProps
  };

  return {
    ...settings,
    formPageSettings: preparedFormPageSettings,
    paymentPageSettings: preparedPaymentPageSettings
  };
}
